import { ApiClient } from '@k2/common/backend/api-client';
import { map } from 'rxjs/operators';

export class AssignmentServiceInstanceEndpoint {
  constructor(private api: ApiClient) {

  }

  getAsinstOverview(assignmentServiceInstanceId: number) {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/overview`);
  };

  getAsinstManagementOverview(assignmentServiceInstanceId: number) {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/management-overview`);
  };

  updateAsinstNotes(assignmentServiceInstanceId: number, notes: string) {
    const data = {
      notes: notes
    };

    return this.api.patch(`/assignment-service-instance/${assignmentServiceInstanceId}/notes`, data);
  };

  updateAsinstNotesAdditional(assignmentServiceInstanceId: number, notes: string) {
    const data = {
      notesAdditional: notes
    };

    return this.api.patch(`/assignment-service-instance/${assignmentServiceInstanceId}/notes-additional`, data);
  };

  updateAsinstIsNeeded(assignmentServiceInstanceId: number, isNeeded: boolean) {
    let data = {
      isNeeded: isNeeded
    };

    return this.api.patch(`/assignment-service-instance/${assignmentServiceInstanceId}/is-needed`, data);
  };

  getDocuments(assignmentServiceInstanceId: number) {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/document`)
      .pipe(map(payload => payload.documents));
  };

  getDocumentFormCreate(assignmentServiceInstanceId: number) {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/document/form-create`)
      .pipe(map(payload => payload.form));
  };

  createDocument(assignmentServiceInstanceId: number, data: any) {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/document`, data);
  };

  getDocumentFormUpdate(assignmentServiceInstanceId: number, documentId: number) {
    return this.api
      .get(`/assignment-service-instance/${assignmentServiceInstanceId}/document/${documentId}/form-update`)
      .pipe(map(payload => payload.form));
  };

  updateDocument(assignmentServiceInstanceId: number, documentId: number, data: any) {
    return this.api.patch(`/assignment-service-instance/${assignmentServiceInstanceId}/document/${documentId}`, data);
  };

  deleteDocument(assignmentServiceInstanceId: number, documentId: number) {
    return this.api.delete(`/assignment-service-instance/${assignmentServiceInstanceId}/document/${documentId}`);
  };
}
